import { render, staticRenderFns } from "./report-summary-1.vue?vue&type=template&id=013cf6ac&scoped=true"
import script from "./report-summary-1.vue?vue&type=script&lang=js"
export * from "./report-summary-1.vue?vue&type=script&lang=js"
import style0 from "./report-summary-1.vue?vue&type=style&index=0&id=013cf6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013cf6ac",
  null
  
)

export default component.exports